



























import { filterMixin } from '@/utils/mixins/filterMixin'
import Autocomplete from '@/components/Autocomplete.vue'
import { getRegions } from '@/api/Address/address'
import { Params } from '@/utils/interfaces'
import { getAgencies } from '@/api/Agency/agency.api'
import { DeliveryCurrenciesEnum } from '~/utils/interfaces/remittance.interface'
import FlatFilter from '~/components/FlatFilter.vue'

export default filterMixin.extend({
  components: {
    appAutocomplete: Autocomplete,
    FlatFilter,
  },
  data() {
    return {
      getRegions: (params?: Params) =>
        getRegions({ ...params, country__name: 'Cuba', limit: 20 }),
      getAgencies: getAgencies,
      deliveryCurrencies: Object.values(DeliveryCurrenciesEnum),
    }
  },
})
